import { aiTaskSuggestions, AITaskSuggestion } from "@/mocks/rop";

interface TaskConfirmationModalProps {
  onClose: () => void;
}

export default function TaskConfirmationModal({ onClose }: TaskConfirmationModalProps) {
  return (
    <div className="fixed inset-0 bg-foreground-950/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg border border-[#D5CA8A] w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 bg-[#FEF3C7] border-b border-[#D5CA8A] rounded-t-lg">
          <div className="flex items-center gap-2">
            <i className="ri-robot-line text-[#D97706]"></i>
            <span className="text-[12px] font-semibold text-[#2D2D2D]">AI-задачи на создание ({aiTaskSuggestions.length})</span>
            <span className="text-[10px] text-[#666666] ml-2">Подтвердите задачи — AI сформировал предложения на основе анализа</span>
          </div>
          <button onClick={onClose} className="w-6 h-6 flex items-center justify-center rounded hover:bg-[#E8DB6C] cursor-pointer">
            <i className="ri-close-line text-[#666666]"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <div className="mb-3 p-2 bg-[#FDF2B5]/50 border border-[#D5CA8A] rounded text-[10px] text-[#666666]">
            <i className="ri-information-line mr-1"></i>
            AI анализирует данные по 15 сценариям ежедневно. Каждая задача формируется на основе конкретного триггера (просрочка, зависание, снижение закупок, проблемы конверсии и т.д.). Подтвердите одним кликом — задача будет создана в 1С и поставлена в ваш личный план работ как РОПа.
          </div>
          <div className="space-y-2">
            {aiTaskSuggestions.map((task: AITaskSuggestion) => (
              <div key={task.id} className="flex items-center gap-3 p-3 border border-[#D5CA8A] rounded-lg hover:bg-[#FDF2B5]/20 transition-colors">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  task.priority === "Критично" ? "bg-[#FEE2E2]" :
                  task.priority === "Высокий" ? "bg-[#FEF3C7]" :
                  task.priority === "Средний" ? "bg-[#E8F4FD]" :
                  "bg-[#D4EDDA]"
                }`}>
                  <i className={`${
                    task.priority === "Критично" ? "ri-alert-fill text-[#DC2626]" :
                    task.priority === "Высокий" ? "ri-arrow-up-circle-fill text-[#D97706]" :
                    task.priority === "Средний" ? "ri-information-line text-[#0369A1]" :
                    "ri-check-line text-[#2D6A4F]"
                  } text-[16px]`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-medium text-[#2D2D2D] truncate">{task.title}</p>
                  <p className="text-[10px] text-[#666666]">{task.reason}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-[9px] text-[#666666] bg-[#FDF2B5] px-1.5 py-0.5 rounded">{task.assignee}</span>
                    <span className={`text-[9px] px-1.5 py-0.5 rounded ${
                      task.priority === "Критично" ? "bg-[#FEE2E2] text-[#DC2626]" :
                      task.priority === "Высокий" ? "bg-[#FEF3C7] text-[#D97706]" :
                      task.priority === "Средний" ? "bg-[#E8F4FD] text-[#0369A1]" :
                      "bg-[#D4EDDA] text-[#2D6A4F]"
                    }`}>{task.priority}</span>
                  </div>
                </div>
                <button className="flex items-center gap-1 px-3 py-2 bg-[#E8DB6C] hover:bg-[#D4C55A] text-[#2D2D2D] rounded text-[11px] font-medium cursor-pointer transition-colors whitespace-nowrap">
                  <i className="ri-check-line text-[12px]"></i>
                  Создать
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-between px-4 py-3 border-t border-[#D5CA8A] bg-[#FFF9E6] rounded-b-lg">
          <span className="text-[10px] text-[#666666]">Будет создано задач: {aiTaskSuggestions.length}</span>
          <div className="flex items-center gap-2">
            <button onClick={onClose} className="px-3 py-1.5 rounded text-[11px] text-[#666666] hover:bg-[#FDF2B5] cursor-pointer transition-colors whitespace-nowrap">
              Отмена
            </button>
            <button onClick={onClose} className="px-3 py-1.5 rounded text-[11px] bg-[#E8DB6C] text-[#2D2D2D] hover:bg-[#D4C55A] font-medium cursor-pointer transition-colors whitespace-nowrap">
              <i className="ri-check-double-line mr-1"></i>
              Создать все ({aiTaskSuggestions.length})
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}